// extracted by mini-css-extract-plugin
module.exports = {"profileContainer":"P125MyProfilePage_profileContainer__nY25_"};